import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { UserListModal } from '@/components/UserListModal';
import { useUserInstalledTools } from '@/hooks/api/useShadowAiTools';

import { COLUMNS, type ShadowAiUserTool } from './constants';

interface UserInfo {
  id: string;
  user: string;
  installedCount: number;
  browserCount: number;
  addedAt: string | null;
  extras?: Record<string, string>;
}

interface ToolsUserToolsListModalProps {
  open: boolean;
  onClose: () => void;
  user: UserInfo | null;
}

export function UserInstalledToolsModal({
  open,
  onClose,
  user,
}: ToolsUserToolsListModalProps): ReactElement | null {
  const { organizationId } = useParams<{ organizationId: string }>();
  const query = useUserInstalledTools(organizationId, user?.id ?? null, open);

  if (!user) {
    return null;
  }

  return (
    <UserListModal<ShadowAiUserTool>
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose();
        }
      }}
      title={
        <>
          Tools used by <span className="font-mono">{user.user}</span>
        </>
      }
      query={query}
      columns={COLUMNS}
      emptyState="No tools found for this user"
    />
  );
}
